export default __webpack_public_path__ + "locales/fr/ArchiveDialog.json?hash=508cbc117c155c6be667479088f819e6";